<template>
  <div :class="[classes, 'border-3 border-white border-t-3 rounded-full animate-spin']"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const { color = "blue", size = 5 } = defineProps<{
  readonly size?: number;
  readonly color?: string;
}>();

const classes = computed(() => `w-${size} h-${size} border-t-${color}-600`);
</script>